import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function About() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="about-page" className="bg-sand">
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 items-center gap-12 lg:gap-16">
          <div className="lg:col-span-6">
            <span className="eyebrow">Our Story</span>
            <h1 className="font-serif text-5xl sm:text-6xl text-navy mt-5 leading-[1.02]">Built for adults. <span className="italic text-copper">Built for Texas.</span></h1>
            <div className="divider my-7" />
            <p className="text-lg text-charcoal/90 leading-relaxed font-light">
              {s?.about_text}
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="aspect-[4/5] overflow-hidden bg-sand">
              <img src="https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=1200&q=80" alt="Texas hemp wellness storefront" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-sand/50 border-t border-copper/20 py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl">
            <span className="eyebrow">What We Stand For</span>
            <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-4 leading-tight">Four principles, every product, every day.</h2>
            <div className="divider my-6" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 mt-14">
            {[
              { t: "Quality", b: "Every batch we stock is selected for terpene profile, cannabinoid content, and ingredient quality. No bottom-shelf inventory." },
              { t: "Transparency", b: "Each product carries a batch number and a third-party Certificate of Analysis. Ingredients are listed in plain English." },
              { t: "Community", b: "We serve real Texans — first-time customers, daily consumers, seniors, and professionals. Our staff is here to answer questions without judgment." },
              { t: "Compliance", b: "We follow Texas hemp retail rules carefully. Our age gate, shipping framework, and product selection adapt as state guidance evolves." },
            ].map((p) => (
              <div key={p.t}>
                <h3 className="font-serif text-3xl text-navy">{p.t}</h3>
                <p className="mt-4 text-charcoal/85 leading-relaxed text-base">{p.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
